// extracted by mini-css-extract-plugin
export default {"root":"AddTag_root__TKwrb","icon":"AddTag_icon__xFgPZ","text":"AddTag_text__FYw3G"};